import React, { useEffect, useState } from 'react';
import classes from './Header.module.scss';
import CountUp from 'react-countup';
import { formatBalance } from '@homeplay/utils';
import { useSelector } from 'react-redux';
import { selectActiveCampaignBonusBalance, selectUnitId } from '@homeplay/app';

const Balance = ({ user, balance, depositBalance, bonus }) => {
  const [bonusValue, setBonusValue] = useState(0);
  const unitId = useSelector(selectUnitId);
  const campaignBonus = useSelector(selectActiveCampaignBonusBalance);
  const totalBalance = balance + depositBalance;

  useEffect(() => {
    setBonusValue(bonus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unitId]);

  // NOTE: Total is real money only, bonuses go to the second line
  if (user && (bonus > 0 || campaignBonus > 0)) {
    return (
      <div className={classes.Balance}>
        Total: <span>{formatBalance(totalBalance)}</span>
        <br />
        {campaignBonus > 0 && (
          <>
            Bonus: <span>{formatBalance(campaignBonus)}</span>
          </>
        )}
        {campaignBonus > 0 && bonus > 0 && ' · '}
        {bonus > 0 && (
          <>
            Free Spins:{' '}
            <CountUp
              start={bonusValue}
              end={bonus}
              onEnd={() => setBonusValue(bonus)}
              formattingFn={formatBalance}
            />
          </>
        )}
      </div>
    );
  }

  return <div>{totalBalance || user ? formatBalance(totalBalance) : null}</div>;
};

export default Balance;
